import { useCallback, useEffect, useState } from "react";
import { fetchContacts } from "./smsApi";
import type { SmsContact } from "./types";

export type ContactMap = Record<string, SmsContact>;

// Shared hook so every SMS view that needs contact metadata (for names +
// `list_type` badges in the conversation list, thread header, compose
// dropdown, etc.) goes through the same fetch + cache-busting key.
// `refreshKey` bumps when the Contacts view CRUD's a row so other views
// re-fetch without a full page refresh.
export function useContacts(refreshKey: number) {
  const [contacts, setContacts] = useState<SmsContact[]>([]);
  const [byNumber, setByNumber] = useState<ContactMap>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const rows = await fetchContacts();
      setContacts(rows);
      const map: ContactMap = {};
      for (const row of rows) {
        map[row.phone_number] = row;
      }
      setByNumber(map);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload, refreshKey]);

  return { contacts, byNumber, loading, error, reload };
}
